module.exports = __webpack_public_path__ + "img/loading.2f698d57.gif";